export default "__VITE_ASSET__615bcdad__"